import "core-js/modules/es6.object.assign";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins.js"; // import {errorCode} from '@/config/errorCode'

import { addresource, resourcelist, resourcedel, resource_update, getmodule, getmodule_api } from '@/api/auth';
import addInterface from './interfaceManCom/addInterface';
export default {
  name: "interfaceManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      headBtnList: [{
        name: '查询',
        type: 'primary',
        method: this.search
      }, {
        name: '重置',
        type: 'error',
        method: this.reset
      }],
      headBtnList1: [{
        name: '新增',
        type: 'primary',
        icon: 'ios-add',
        method: this.addModuleShow
      }, {
        name: '刷新',
        icon: 'ios-refresh',
        type: 'primary',
        method: this.init
      }],
      moduleData: [],
      //模块
      stateData: [{
        value: -1,
        label: '全部'
      }, {
        value: 0,
        label: '禁用'
      }, {
        value: 1,
        label: '启用'
      }],
      form_filter: {
        mod_code: null,
        state: null,
        res_name: null
      },
      searchReq: {
        mods: []
      },
      tableData: [],
      columnsData: [{
        title: '接口',
        key: 'res_name',
        align: 'center'
      }, {
        title: '所属模块',
        key: 'mod_name',
        align: 'center'
      }, {
        title: '说明',
        key: 'res_desc',
        align: 'center'
      }, {
        title: '状态',
        key: 'state',
        align: 'center',
        render: function render(h, _ref) {
          var row = _ref.row;

          if (row.state) {
            var state = _this2.states.filter(function (item) {
              return item.value == row.state;
            });

            return h("span", state[0].label || '无');
          }
        }
      }, {
        title: '操作',
        key: 'explain',
        align: 'center',
        width: 150,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          var but = h("div", [h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: '#2d8cf0'
            },
            props: {
              size: "small",
              type: 'text'
            },
            on: {
              "click": function click() {
                _this2.edit(row);
              }
            }
          }, "编辑"), h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: '#2d8cf0'
            },
            props: {
              size: "small",
              type: "text"
            },
            on: {
              "click": function click() {
                _this2.delModule(row);
              }
            }
          }, "删除")]);
          return but;
        }
      }],
      tableLoading: false,
      tabletotallen: 0,
      border: true,
      stripe: true,
      moduleShow: false,
      addBase: {
        name: "",
        code: "",
        state: "",
        explain: ""
      },
      reqBase: {
        page: 1
      },
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      modalTitle: true,
      ruleValidate: {
        name: [{
          required: true,
          message: '请输入模块名',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入模块代码',
          trigger: 'change'
        }],
        explain: [{
          required: true,
          message: '请输入说明',
          trigger: 'blur'
        }],
        state: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }]
      }
    };
  },
  components: {},
  computed: {},
  methods: {
    reset: function reset() {
      this.form_filter = {
        state: null,
        mod_code: null,
        res_name: null
      };
      this.search();
    },
    search: function search() {
      this.onSearch(this.form_filter);
    },
    init: function init() {
      this.getPageSizeToStorage();
      this.getData();
    },

    /**
     * 初始化数据
     */
    getData: function getData() {
      var _this3 = this;

      this.tableLoading = true;
      var vm = this; //;

      var callbak = function callbak(res) {
        _this3.tableLoading = false;

        if (res.result === 0) {
          vm.tableData = res.body.list || [];
          vm.tabletotallen = res.body.total;
        } else {
          vm.tableData = [];

          _this3.$Message.error(res.errorMsg);
        }
      };

      var state = this.reqBase.state;

      if (this.reqBase.state === -1) {
        state = "";
      }

      var mod_code = this.reqBase.mod_code;

      if (this.reqBase.mod_code == -1) {
        mod_code = "";
      }

      resourcelist(_objectSpread({}, this.reqBase, {
        state: state,
        mod_code: mod_code
      })).then(function (res) {
        callbak(res);
      });
    },

    /**
     * 重置搜索框
     */
    resetSearch: function resetSearch() {
      this.searchReq = {
        mods: []
      };
    },
    okSearch: function okSearch() {
      Object.assign(this.reqBase, this.searchReq); //重置当前页为1

      this.reqBase.page = 1;
      this.$refs.contentBaseRef.initcurrentPage();
      this.init();
    },

    /**
     * 翻页
     */
    pageonChange: function pageonChange(index) {
      this.reqBase.page = index;
      this.getData();
    },

    /**
     * 筛选
     */
    showSearchParel: function showSearchParel() {
      this.$refs.search.expandPanel();
    },

    /**
     * 控制模态框显示隐藏
     * type 显示隐藏
     * handle true新增 false编辑
     * row 本条数据
     */
    addModuleShow: function addModuleShow() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var handle = arguments.length > 1 ? arguments[1] : undefined;
      var row = arguments.length > 2 ? arguments[2] : undefined;
      var vm = this;
      var config = {
        loading: true,
        width: 600,
        okText: '确定',
        cancelText: '取消',
        render: function render(h) {
          return h('div', [h('h3', "新增接口"), h(addInterface, {
            ref: 'addInterface',
            props: {
              edit: false,
              moduleData: vm.moduleData,
              $store: vm.$store,
              _vm: vm
            }
          })]);
        },
        onOk: function onOk() {
          var _this4 = this;

          var _this = this;

          var obj = this.$refs.addInterface;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              addresource(_objectSpread({}, formModel)).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(_this4.$t('添加成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    edit: function edit(row) {
      var vm = this;
      var config = {
        loading: true,
        width: 600,
        okText: '确定',
        cancelText: '取消',
        render: function render(h) {
          return h('div', [h('h3', "编辑接口"), h(addInterface, {
            ref: 'addInterface',
            props: {
              edit: true,
              _vm: vm,
              setData: row,
              moduleData: vm.moduleData,
              $store: vm.$store
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addInterface;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              resource_update(_objectSpread({}, formModel)).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('修改成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },

    /**
     * 删除
     */
    delModule: function delModule(row) {
      var _this5 = this;

      var _this = this;

      var config = {
        loading: true,
        title: "删除接口",
        width: 400,
        content: "<p>\u786E\u8BA4\u5220\u9664\u63A5\u53E3<span style=\"color: #f60;\">".concat(row.res_name, "</span>\uFF1F</p>"),
        onOk: function onOk() {
          var params = {
            id: row.id
          },
              callbak = function callbak(req) {
            if (req.result === 0) {
              _this5.$Message.success(_this5.$t('删除成功！'));

              _this5.$Modal.remove();

              _this5.init();
            } else {
              _this5.buttonLoading = false;

              _this5.$Message.error(req.errorMsg);
            }
          }; //删除接口


          resourcedel(params).then(function (res) {
            callbak(res);
          });
        }
      };
      this.$Modal.confirm(config);
    },
    initModuleData: function initModuleData() {
      var _this6 = this;

      this.moduleData = [];
      getmodule({}).then(function (res) {
        if (res.result === 0) {
          _this6.moduleData = res.body || [];
        }
      });
    }
  },
  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    this.initModuleData();
  }
};